import React, { Fragment } from 'react';
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material';
import { Assignment, ListOutlined, Numbers } from '@mui/icons-material';
import { useStyles } from './estilos';

const CardElemento = ({datosDelMedio, asignarPlanDeMedio, idTipoMedioDeComunicacion}) => {
  const {nivelCobertura, nombreMedio} = datosDelMedio
  const classes = useStyles();
  return (
    <Grid item xs={12} md={4}>
      <Card style={{ minWidth: '100%', width: '100%' }}>
        <CardContent>
            <Typography className={classes.titulo}>{nombreMedio}</Typography>
            <div className={classes.contenedorCoberturas} >
              <div className={`${classes.contenedorCoberturas_item} ${classes.contenedorCoberturas_item_fisrt}`}>
                  <ListOutlined  className={classes.contenedorCoberturas_item_icon} />
              </div>
              <div className={`${classes.contenedorCoberturas_item} ${classes.contenedorCoberturas_item_second}`}>
                  <Numbers className={classes.contenedorCoberturas_item_icon} />
              </div>
              <div className={classes.contenedorCoberturas_item}>
                  <Assignment  className={classes.contenedorCoberturas_item_icon} />
              </div>
            </div>
            <Divider />
              {nivelCobertura?.map( (item) => (
                <Fragment key={item.id}>
                  <div className={classes.contenedorCoberturas} >
                    <div className={`${classes.contenedorCoberturas_item} ${classes.contenedorCoberturas_item_fisrt}`}>
                        <Typography className={classes.contenedorCoberturas_item_text}>{item?.name || ""}</Typography>
                    </div>
                    <div className={`${classes.contenedorCoberturas_item} ${classes.contenedorCoberturas_item_second}`}>
                        <Typography className={classes.contenedorCoberturas_item_text}>Q {item?.tarifa_electoral || ""}</Typography>
                    </div>
                    <div className={classes.contenedorCoberturas_item}>
                        <Button variant="contained" color="primary" onClick={() => asignarPlanDeMedio(datosDelMedio, item, idTipoMedioDeComunicacion)} className={classes.contenedorCoberturas_item_boton}>
                          Asignar
                        </Button>
                    </div>
                  </div>
                  <Divider />
                </Fragment>
              ))}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default CardElemento;